import { getDate } from "date-fns";

const GetFormattedDateTime = (dateString, showTime = false) => {
  const fromDate = localStorage.getItem("fromDate") || "";
  const toDate = localStorage.getItem("toDate") || "";
  const quickFilter = localStorage.getItem("quickFilter") || "";
  // const isTime =
  //   (fromDate == toDate && fromDate != "") ||
  //   (quickFilter === "FTD" && fromDate == "")
  //     ? true
  //     : false;
  const isTime = showTime;
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear());
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? String(hours).padStart(2, "0") : "12";

  const formattedDate = `${day}-${month}-${year}`;
  const formattedTime = `${hours}:${minutes} ${ampm}`;
  return `${!isTime ? formattedDate : ""} ${isTime ? (formattedDate+' : '+formattedTime) : ""}`;
};

export default GetFormattedDateTime;
